interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-between gap-3" aria-label="分页导航">
      <p className="text-xs text-foreground-500">
        第 {page} / {totalPages} 页
      </p>
      <div className="flex items-center gap-1.5">
        <button
          type="button"
          onClick={() => onChange(Math.max(1, page - 1))}
          disabled={page === 1}
          className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
          aria-label="上一页"
        >
          <i className="ri-arrow-left-s-line text-lg" />
        </button>
        {pages.map((item) => (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            aria-current={item === page ? "page" : undefined}
            className={`h-9 min-w-9 rounded-md px-2 text-sm transition-colors ${
              item === page
                ? "bg-primary-500 font-medium text-background-50"
                : "border border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
            }`}
          >
            {item}
          </button>
        ))}
        <button
          type="button"
          onClick={() => onChange(Math.min(totalPages, page + 1))}
          disabled={page === totalPages}
          className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
          aria-label="下一页"
        >
          <i className="ri-arrow-right-s-line text-lg" />
        </button>
      </div>
    </nav>
  );
}